/**
* This file was automatically generated by @cosmwasm/ts-codegen@0.33.0.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run the @cosmwasm/ts-codegen generate command to regenerate this file.
*/

import { InstantiateMsg, ExecuteMsg, ExecMsg, Addr, UserProfile, QueryMsg, QueryMsg1, NullableUser, User } from "./UserProfileContract.types";
import { CamelCasedProperties } from "type-fest";
export abstract class UserProfileContractExecuteMsgBuilder {
  static createUser = ({
    profile,
    referrer
  }: CamelCasedProperties<Extract<ExecuteMsg, {
    create_user: unknown;
  }>["create_user"]>): ExecuteMsg => {
    return {
      create_user: ({
        profile,
        referrer
      } as const)
    };
  };
  static updateProfile = ({
    newProfile
  }: CamelCasedProperties<Extract<ExecuteMsg, {
    update_profile: unknown;
  }>["update_profile"]>): ExecuteMsg => {
    return {
      update_profile: ({
        new_profile: newProfile
      } as const)
    };
  };
}
export abstract class UserProfileContractQueryMsgBuilder {
  static getUserByUserName = ({
    userName
  }: CamelCasedProperties<Extract<QueryMsg, {
    get_user_by_user_name: unknown;
  }>["get_user_by_user_name"]>): QueryMsg => {
    return {
      get_user_by_user_name: ({
        user_name: userName
      } as const)
    };
  };
  static getUser = ({
    addr
  }: CamelCasedProperties<Extract<QueryMsg, {
    get_user: unknown;
  }>["get_user"]>): QueryMsg => {
    return {
      get_user: ({
        addr
      } as const)
    };
  };
}